import { postNoBrand } from '../api';

const authRefreshTokenEndpoint = '/partner/auth/refresh-token';

export const refreshAuthToken = () => postNoBrand(authRefreshTokenEndpoint);

export default refreshAuthToken;
